import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Sun, Moon, Menu, X } from 'lucide-react';
import { useApp } from '../contexts/AppContext';
import { useAuth } from '../contexts/AuthContext';

const LandingNavigation = () => {
    const { theme, toggleTheme } = useApp();
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleGetStarted = () => {
        if (currentUser) {
            navigate('/dashboard');
        } else {
            navigate('/login');
        }
    };

    return (
        <nav className={`landing-nav ${isScrolled ? 'scrolled' : ''}`}>
            <Link to="/" className="landing-nav-logo">
                <img src="/favicon.png" alt="Vitisiti" className="landing-nav-logo-icon" />
                <span>Vitisiti</span>
            </Link>

            <div className="landing-nav-links">
                <a href="#features" className="landing-nav-link">Features</a>
                <Link to="/pricing" className="landing-nav-link">Pricing</Link>
            </div>

            <div className="landing-nav-actions">
                <button
                    onClick={toggleTheme}
                    className="btn btn-icon btn-ghost"
                    aria-label="Toggle theme"
                >
                    {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
                </button>

                {currentUser ? (
                    <button
                        onClick={() => navigate('/dashboard')}
                        className="btn btn-primary"
                    >
                        Go to Dashboard
                    </button>
                ) : (
                    <>
                        <button
                            onClick={() => navigate('/login')}
                            className="btn btn-ghost"
                        >
                            Sign In
                        </button>
                        <button
                            onClick={handleGetStarted}
                            className="btn btn-primary"
                        >
                            Get Started
                        </button>
                    </>
                )}

                <button
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    className="btn btn-icon btn-ghost landing-nav-mobile-toggle"
                    aria-label="Toggle menu"
                >
                    {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div
                    style={{
                        position: 'fixed',
                        top: '70px',
                        left: 0,
                        right: 0,
                        background: 'var(--color-surface)',
                        borderBottom: '1px solid var(--color-border)',
                        padding: 'var(--space-4)',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 'var(--space-2)',
                        zIndex: 'var(--z-fixed)',
                    }}
                >
                    <a
                        href="#features"
                        className="landing-nav-link"
                        style={{ padding: 'var(--space-3)' }}
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Features
                    </a>
                    <Link
                        to="/pricing"
                        className="landing-nav-link"
                        style={{ padding: 'var(--space-3)' }}
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Pricing
                    </Link>
                    {!currentUser && (
                        <button
                            onClick={() => {
                                navigate('/login');
                                setIsMobileMenuOpen(false);
                            }}
                            className="btn btn-ghost"
                            style={{ justifyContent: 'flex-start' }}
                        >
                            Sign In
                        </button>
                    )}
                </div>
            )}
        </nav>
    );
};

export default LandingNavigation;
